import { MultiSelect } from 'primereact/multiselect';
import React, { useState } from 'react';
import searchIcon from '../../assets/images/search-icon.svg';
import { CheckIcon } from '../../components/icons';

const CustomMultiSelectHeader = React.memo(
	({ filterValue, filterPlaceholder, onSearchChange, onSelectAll, allSelected, searchValue }) => {
		const selectedCount = filterValue.length;
		const [localSearchValue, setLocalSearchValue] = useState('');

		return (
			<div className="p-multiselect-header custom-header">
				<div className="p-multiselect-filter-container">
					<span className="p-input-icon-right">
						<img src={searchIcon} alt="search" />
						<input
							className="p-multiselect-filter p-inputtext p-component"
							type="text"
							value={searchValue}
							onChange={(e) => {
								onSearchChange(e.target.value);
								setLocalSearchValue(e.target.value);
							}}
							placeholder={filterPlaceholder}
						/>
					</span>
				</div>
				<div className="selected-count">
					<strong>Selected ({selectedCount})</strong>
				</div>
				<div
					className="p-checkbox p-component"
					onClick={onSelectAll}
					onKeyDown={(e) => {
						if (e.key === 'Enter' || e.key === ' ') {
							onSelectAll();
						}
					}}
					role="checkbox"
					aria-checked={allSelected}
					tabIndex={0}
				>
					<div className={`p-checkbox-box ${allSelected ? 'p-highlight' : ''}`}>
						{allSelected && <CheckIcon color="#fff" />}
					</div>
					{localSearchValue ? 'Select All Search Results' : 'Select All'}
				</div>
			</div>
		);
	}
);

const ReportScreenFilters = ({ filtersConfig, filters, onFilterChange, resetFilteredOptions, onSearchChange }) => {
	return (
		<div className="report-screen-filters">
			{filtersConfig?.map((filterConfig) => {
				const { filteredOptions, field, name } = filterConfig;

				const allSelected =
					filteredOptions.length > 0 &&
					filteredOptions.every((option) => filters[field]?.value?.includes(option.value));

				const onSelectAll = () => {
					const allValues = filteredOptions.map((option) => option.value);
					onFilterChange(field, allSelected ? [] : allValues);
				};

				const onChange = (e) => onFilterChange(field, e.value);
				const onHide = () => resetFilteredOptions(field);
				const onMultiSelectSearch = (value) => onSearchChange(field, value)(field);

				return (
					<div key={field} className="report-screen-filter">
						{/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
						<label>{filters[field].value.length > 0 && name}</label>
						<MultiSelect
							filterPlaceholder={name}
							value={filters[field]?.value || []}
							options={filteredOptions}
							maxSelectedLabels={0}
							onChange={onChange}
							onHide={onHide}
							optionLabel="label"
							placeholder={name}
							aria-label={`Multi-select filter for ${name}`}
							resetFilterOnHide
							filter
							panelHeaderTemplate={() => (
								<CustomMultiSelectHeader
									filterValue={filters[field]?.value || []}
									onSelectAll={onSelectAll}
									allSelected={allSelected}
									filterPlaceholder={name}
									onSearchChange={onMultiSelectSearch}
								/>
							)}
						/>
					</div>
				);
			})}
		</div>
	);
};

export default ReportScreenFilters;
